const isMobileApp = process.env.VUE_APP_IS_MOBILE.toString() === 'true'
const storage = isMobileApp ? localStorage : sessionStorage

export const getSession = function(key) {
	return storage.getItem(key)
}

export const setSession = function(key, val) {
	storage.setItem(key, val)
}

export const removeSession = function(key) {
	storage.removeItem(key)
}

export default { getSession, setSession, removeSession }
